/**
 * Studies Service
 * Handles API calls for study operations including public studies.
 */
import API from './api.ts';

/**
 * Get public studies for Open Research Studies page.
 * This endpoint doesn't require authentication.
 * @returns {Promise<Array>} Array of public study objects with enriched data
 */
export async function getPublicStudies() {
    const response = await API.get('/studies/public/');
    return response.data;
}

/**
 * Get a specific study by ID.
 * @param {number} studyId - The study ID
 * @returns {Promise<Object>} Study object
 */
export async function getStudy(studyId) {
    const response = await API.get(`/studies/${studyId}/`);
    return response.data;
}

/**
 * Get all studies for current user.
 * @returns {Promise<Array>} Array of study objects
 */
export async function getAllStudies() {
    const response = await API.get('/studies/');
    return response.data;
}

/**
 * Toggle study public visibility.
 * @param {number} studyId - The study ID
 * @returns {Promise<Object>} Updated study object
 */
export async function toggleStudyPublic(studyId) {
    const response = await API.post(`/studies/${studyId}/toggle-public/`);
    return response.data;
}

export default {
    getPublicStudies,
    getStudy,
    getAllStudies,
    toggleStudyPublic,
};
